import { Pipe, PipeTransform } from '@angular/core';
import { sourceSetToBackgroundImage } from '../utils';

@Pipe({
  name: 'backgroundImgSet',
  standalone: true,
  pure: true,
})
export class BackgroundImgSet implements PipeTransform {
  transform(images: string | string[]) {
    if (images?.length && Array.isArray(images)) {
      return sourceSetToBackgroundImage(images as string[]);
    }
    return images ? `url(${images})` : '';
  }
}
